<template>
  <ExaminationFormV2
      v-if="useNewEyeExamForm"
      :initExamination="initExamination"
      :initCustomer="initCustomer"
      :successMsg="successMsg"
      :submitAction="submitAction"
      :enablePrint="enablePrint"
      enableClearForm
      clearFormOnSubmit/>
  <ExaminationFormV1
      v-else
      :initExamination="initExamination"
      :initCustomer="initCustomer"
      :successMsg="successMsg"
      :submitAction="submitAction"
      :enablePrint="enablePrint"
      enableClearForm
      clearFormOnSubmit/>
</template>
<script lang="ts">
import {useSettingsStore} from "@/stores/settingsStore";
import ExaminationFormV1 from './ExaminationFormV1.vue'
import ExaminationFormV2 from './ExaminationFormV2.vue'
import {defineComponent} from "vue";
import Customer from "@/models/customer/Customer";
import Examination, {hasRetinoscopyPart} from "@/models/customer/Examination";

export default defineComponent({
  name: 'examination-form-version-selector',
  components: {
    ExaminationFormV1,
    ExaminationFormV2
  },
  props: {
    initCustomer: {
      type: Customer,
      required: true
    },
    initExamination: {
      type: Examination,
      required: true
    },
    submitAction: {
      type: Function,
      required: true
    },
    successMsg: {
      type: String,
      required: true
    },
    enableClearForm: {
      type: Boolean,
      required: false
    },
    clearFormOnSubmit: {
      type: Boolean,
      default: false
    },
    enablePrint: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    // Retinoscopy lives in the new Eye Exam page, so exams that hold one always open there
    useNewEyeExamForm(): boolean {
      return useSettingsStore().getValue('use_new_version_of_examination_creator') == 'true'
          || hasRetinoscopyPart(this.initExamination)
    }
  }
});
</script>
